const colorsJson = require('./colors.json');

// In production builds, JSON imports can be nested under a 'default' property.
// This line handles both cases gracefully.
const colors = colorsJson.default || colorsJson;

const COLOR_ASSIGNMENTS_KEY = 'colorAssignments_v2';

// Exclude black and white for better visuals
// Añadir verificación de que colors.colores_distintos existe
const colorPalette = (colors.colores_distintos  || [])
  .map(color => color.hex)
  .filter(hex => hex.toUpperCase() !== '#FFFFFF' && hex.toUpperCase() !== '#000000');

// Si colorPalette está vacío, usar colores por defecto
if (colorPalette.length === 0) {
  console.warn('No colors loaded from JSON, using defaults');
  colorPalette.push('#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2');
}

const getAssignments = () => {
  try {
    const stored = localStorage.getItem(COLOR_ASSIGNMENTS_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    console.error("Failed to read from localStorage", e);
  }
  return { map: {}, nextColorIndex: 0 };
};

const saveAssignments = (assignments) => {
  try {
    localStorage.setItem(COLOR_ASSIGNMENTS_KEY, JSON.stringify(assignments));
  } catch (e) {
    console.error("Failed to save to localStorage", e);
  }
};

export const colorFromString = (str) => {
  if (!str) {
    return colorPalette[0];
  }

  const assignments = getAssignments();

  if (assignments.map[str]) {
    return assignments.map[str];
  }

  const color = colorPalette[assignments.nextColorIndex];
  assignments.map[str] = color;
  assignments.nextColorIndex = (assignments.nextColorIndex + 1) % colorPalette.length;

  saveAssignments(assignments);
  return color;
};